import { render, staticRenderFns } from "./ForgotpasswordOtpverify.vue?vue&type=template&id=41e78d2e&"
import script from "./ForgotpasswordOtpverify.vue?vue&type=script&lang=js&"
export * from "./ForgotpasswordOtpverify.vue?vue&type=script&lang=js&"
import style0 from "./ForgotpasswordOtpverify.vue?vue&type=style&index=0&id=41e78d2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports